import styled from '@emotion/styled';
import type { FC } from 'react';
import { pulsate } from 'src/lib/keyframes';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  margin-left: 4px;
`;

const Circle = styled.span`
  position: relative;
  flex-shrink: 0;
  width: 0.9em;
  height: 0.9em;
  background-color: #62bd19;
  border-radius: 50%;
`;

// Centred on the circle by margins, since the animation owns `transform`.
const Ringring = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 3px solid #62bd19;
  border-radius: 50%;
  animation: ${pulsate(1.2)} 1s ease-out infinite;
  opacity: 0;
`;

export const LiveIndicator: FC = () => (
  <Container>
    <Circle>
      <Ringring />
    </Circle>
  </Container>
);
